import { FleetOperatorNotesScreen } from "@src/features/patriot-tools";

export default FleetOperatorNotesScreen;
